import useAxios from '../use-axios'

import getSafetyItemResponsesRequest from './get-safety-item-responses-request'

const useSafetyItemResponses = (params, queryObject, axiosOptions = {}) => {
  const request = getSafetyItemResponsesRequest(params, queryObject)

  const { data, error, loading, refetch } = useAxios(request, { defaultValue: [], ...axiosOptions })

  return { data, error, loading, execute: refetch }
}

export default useSafetyItemResponses
